import { Head, Link } from '@inertiajs/react'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'

export default function CheckoutCancel() {
  return (
    <>
      <Head title="Order cancelled" />
      <div className="mx-auto flex min-h-[80vh] max-w-xl items-center px-4 py-16">
        <Card className="w-full">
          <CardContent className="space-y-4 py-10 text-center">
            <h1 className="text-2xl font-semibold">Order cancelled</h1>
            <p className="text-muted-foreground">
              No worries — you weren't charged. Head back when you're ready.
            </p>
            <div className="pt-2">
              <Button asChild>
                <Link href="/events">Browse events</Link>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  )
}
